import { useTranslation } from 'react-i18next';
import type { IngredientDetail } from '@/types/product';

interface IngredientDetailCardsProps {
  details: IngredientDetail[];
}

export default function IngredientDetailCards({ details }: IngredientDetailCardsProps) {
  const { t } = useTranslation();

  return (
    <div className="bg-white rounded-2xl p-6 md:p-8 border border-[#E8E8E6]">
      <h3 className="text-sm tracking-[0.12em] uppercase font-medium text-[#2A2A2A] mb-6">
        {t('products.ingredientScience')}
      </h3>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        {details.map((ing, i) => (
          <div
            key={i}
            className="flex flex-col gap-3 p-5 rounded-xl bg-[#FAFAF9] border border-[#F0EFED] hover:border-[#E8E8E6] transition-colors"
          >
            <div className="flex items-center justify-between">
              <span className="text-sm font-semibold text-[#2A2A2A]">{ing.name}</span>
              <span className="text-[10px] tracking-wider uppercase px-2 py-0.5 rounded-full bg-[#7B1113]/10 text-[#7B1113] font-medium">
                {ing.concentration}
              </span>
            </div>

            <div className="flex flex-col gap-1">
              <span className="text-[10px] tracking-wider uppercase text-[#8A8A8A] font-medium">
                {t('products.inciName')}
              </span>
              <span className="text-xs text-[#2A2A2A] font-light italic">{ing.inciFull}</span>
            </div>

            <div className="flex flex-col gap-1">
              <span className="text-[10px] tracking-wider uppercase text-[#8A8A8A] font-medium">
                {t('products.clinicalEvidence')}
              </span>
              <span className="text-xs text-[#8A8A8A] font-light leading-relaxed">{ing.clinicalRef}</span>
            </div>

            <div className="flex flex-col gap-1">
              <span className="text-[10px] tracking-wider uppercase text-[#8A8A8A] font-medium">
                {t('products.benefit')}
              </span>
              <span className="text-xs text-[#2A2A2A] font-light leading-relaxed">{ing.benefitSummary}</span>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}